import React, { Fragment } from 'react';
import reqCredit from '../../../../images/consumer/reqCredit.svg';
const ReqCreditReport = () => {
  return (
    <Fragment>
      <div className="flex flex-col w-full md:min-w-50v justify-around mx-auto content-center  overflow-auto ">
        <div className="mt-5 mx-auto">
          <img src={reqCredit} alt="" />
        </div>
        <div className="mx-auto">
          <button type="submit" className="submitButton w-57 h-14 ">
            Request Credit Report
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default ReqCreditReport;
